import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import { Context } from "../context";
import { getImage, getDataById, getDataByUniq } from './utils';

import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Select } from "../uikit/Select";



export function MenuMain({
  space = 'personal'//personal/company
}) {
  const context = useContext(Context);
  return (
    <>
      <div className="m_collapsible0">
        <div className="m0">
          <div className="m0_sticky">
            <MenuInner space />
          </div>
        </div>
        <div className="m0_collapsed">
          <div className="m0_sticky">
            <MenuInner space />
          </div>
        </div>
        <div className="m0_z" />
      </div>
    </>
  );
}

export function MenuInnerInner(props) {
  const { history, match, location, space } = { ...props };

  const activeSpace = match.params['space'] ?? 'personal';
  const context = useContext(Context);

  const grid = 8;
  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    // padding: grid * 2,
    // margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? "lightgreen" : "transparent",

    // styles we need to apply on draggables
    ...draggableStyle
  });

  return (
    <>
      {<>
        <div className="m_top">





          <div className="l_c_menu_info">


            <Select
              dropStyle={{
                padding: "0.1em",
              }}
              dropItemStyle={{
                borderRadius: "0.2em",
                padding: "0.4em 1em",
                margin: "0.2em",
                minHeight: 32,
              }}
							// colors={{ ...selectColors }}
              multiSelect={false}
              width={220}
              // size="sm"
              placeholder="All teams"
              active={activeSpace}

              itemActiveCustom={
                () => (<div className="x_team_logo">
                  <div className="x_prj_icon"
                    style={{
                      backgroundColor: getDataByUniq(context, 'spaces', activeSpace, 'color'),
                    }}
                  >
                    {getDataByUniq(context, 'spaces', activeSpace, 'titleShort')}
                  </div>
                  <div className="l_c_menu_info_h">
                    {getDataByUniq(context, 'spaces', activeSpace, 'title')}
                  </div>
                </div>)
              }
              menuHandler={(val) => {
                history.push(`/${val}/smartcaptures`)
              }}
              options={[
                ...context.data.spaces.map((team) => {
                  return {
                    // title: <>{tag["title"]} - {filterByCategory(tag['items'], category).length}</>,
                    title: <>{team["title"]}</>,
                    // icon: <MIcon size={18}>add</MIcon>,
                    icon: (
                      <>
                        {/* {team["img"] && <div
                            className="x_project_ava_img"
                            style={{
                              // backgroundColor: user["color"], margin: 0,
                              backgroundImage: `url(${getImage(team["img"], "small")})`,
                            }}
                          />}

                          {team["emoji"] && <div
                            className="x_project_ava_img"
                            style={{
                              backgroundImage: 'none',
                              backgroundColor: 'transparent',
                            }}
                          >
                            <div className="flex">{team["emoji"]}</div>
                          </div>} */}

                        {team["titleShort"] && <div
                          className="x_prj_icon"
                          style={{
                            backgroundImage: 'none',
                            backgroundColor: team['color'],
                          }}
                        >
                          {team['titleShort']}
                        </div>}
                      </>
                    ),
                    value: team["uniq"],
                    // separated: true,
                  };
                })
              ]}
            />




          </div>



          {getDataByUniq(context, 'spaces', match.params['space'], 'type') === 'personal' && <>

            <div className="l_c_menu_section">
              <div className="l_c_menu_ul">
                <div className="l_c_menu_li">
                  <div className="l_c_menu_item">
                    <div className="l_c_menu_ico">
                      <div className="ico">
                        <div>search</div>
                      </div>
                    </div>
                    <div className="l_c_menu_label">
                      <div>Search</div>
                    </div>
                  </div>
                </div>
                <div className="l_c_menu_li">
                  <div className="l_c_menu_item">
                    <div className="l_c_menu_ico">
                      <div className="ico">
                        <div>history</div>
                      </div>
                    </div>
                    <div className="l_c_menu_label">
                      <div>History</div>
                    </div>
                  </div>
                </div>
                <div className="l_c_menu_li">
                  <div className="l_c_menu_item">
                    <div className="l_c_menu_ico">
                      <div className="ico">
                        <div>bookmark</div>
                      </div>
                    </div>
                    <div className="l_c_menu_label">
                      <div>Bookmarks</div>
                    </div>
                  </div>
                </div>

                <div className="l_c_menu_li">
                  <Link to={`/${match.params['space']}/smartcaptures`}
                    className={`l_c_menu_item ${location.pathname.indexOf('smartcaptures') !== -1 ? 'active' : ''}`}
                  >
                    <div className="l_c_menu_ico">
                      <div className="ico">
                        <div>smart_display</div>
                      </div>
                    </div>
                    <div className="l_c_menu_label">
                      <div>All smartcaptures</div>
                    </div>
                  </Link>
                </div>

                {/* <div className="l_c_menu_li">
                  <div className="l_c_menu_item">
                    <div className="l_c_menu_ico">
                      <div className="ico">
                        <div>visibility_off</div>
                      </div>
                    </div>
                    <div className="l_c_menu_label">
                      <div>Unpublished</div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>


          </>}










          {getDataByUniq(context, 'spaces', match.params['space'], 'type') === 'managed' && <>

            <div className="l_c_menu_section">

              <div className="l_c_menu_title">
                <div>Workspace</div>
              </div>
              <div className="l_c_menu_ul">
                <div className="l_c_menu_li">
                  <div className="l_c_menu_item">
                    <div className="l_c_menu_ico">
                      <div className="ico">
                        <div>search</div>
                      </div>
                    </div>
                    <div className="l_c_menu_label">
                      <div>Workplace search</div>
                    </div>
                  </div>
                </div>
                <div className="l_c_menu_li">
                  <div className="l_c_menu_item">
                    <div className="l_c_menu_ico">
                      <div className="ico">
                        <div>settings</div>
                      </div>
                    </div>
                    <div className="l_c_menu_label">
                      <div>Settings</div>
                    </div>
                  </div>
                </div>
                <div className="l_c_menu_li">
                  <div className="l_c_menu_item">
                    <div className="l_c_menu_ico">
                      <div className="ico">
                        <div>group</div>
                      </div>
                    </div>
                    <div className="l_c_menu_label">
                      <div>Users &amp; access</div>
                    </div>
                  </div>
                </div>


                <div className="l_c_menu_li">
                  <div className="l_c_menu_item">
                    <div className="l_c_menu_ico">
                      <div className="ico">
                        share
                      </div>
                    </div>
                    <div className="l_c_menu_label">
                      <div>Shared</div>
                    </div>
                  </div>
                </div>

                <div className="l_c_menu_li">
                  <Link to={`/${match.params['space']}/smartcaptures`}
                    className={`l_c_menu_item ${location.pathname.indexOf('smartcaptures') !== -1 ? 'active' : ''}`}
                  >
                    <div className="l_c_menu_ico">
                      <div className="ico">
                        <div>smart_display</div>
                      </div>
                    </div>
                    <div className="l_c_menu_label">
                      <div>All smartcaptures</div>
                    </div>
                  </Link>
                </div>

              </div>
            </div>


          </>}






          <div className="l_c_menu_section">

            <div className="l_c_menu_title">
              <div>Private playlists</div>
            </div>


            <DragDropContext
            // onDragEnd={this.onDragEnd}
            >
              <Droppable droppableId="droppable">
                {(provided, snapshot) => (

                  <div
                    className="m_ul"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    {context.data["playlists"]
                      // .filter((one) => one['type'] === 'searchBased')
                      .filter((one) => {
                        let space = getDataById(context, 'spaces', one['space'], 'uniq');
                        return space === match.params['space']
                      })
                      .map((one, index) => (

                        <Draggable key={`playlist_${one["id"]}`} draggableId={`playlist_${one["id"]}`} index={index}>
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style
                              )}
                            >
                              <MenuPlaylist
                                active={match.params['playlistId'] === one["uniq"]}
                                // key={`playlist_${one["id"]}`}
                                {...one}
                                {...props}
                              />
                            </div>

                          )}
                        </Draggable>
                      ))}




                  </div>

                )}
              </Droppable>
            </DragDropContext>

            <div className="l_c_menu_li">
              <div className="l_c_menu_item l_c_menu_item--add">
                <div className="l_c_menu_ico">
                  <div className="ico">
                    <div>add</div>
                  </div>
                </div>
                <div className="l_c_menu_label">
                  <div>Create playlist</div>
                </div>
              </div>
            </div>



          </div>




          <div className="l_c_menu_section"><div className="l_c_menu_title"><div>To DO</div></div><div className="l_c_menu_ul"><div className="l_c_menu_li"><div className="l_c_menu_item l_c_menu_item--add"><div className="l_c_menu_ico"><div className="ico"><div>download</div></div></div><div className="l_c_menu_label"><div>Download Desktop app</div></div></div></div><div className="l_c_menu_li"><div className="l_c_menu_item l_c_menu_item--add"><div className="l_c_menu_ico"><div className="ico"><div>groups</div></div></div><div className="l_c_menu_label"><div>Respond to a team request</div></div></div></div></div></div>






        </div>

        <div className="m_bot">
          <div className="l_c_menu_section">
            <div className="l_c_menu_ul">
              <div className="l_c_menu_li">
                <div className="l_c_menu_item">
                  <div className="l_c_menu_ico">
                    <div className="ico">
                      <div>tune</div>
                    </div>
                  </div>
                  <div className="l_c_menu_label">
                    <div>Settings</div>
                  </div>
                </div>
              </div>
              <div className="l_c_menu_li">
                <div className="l_c_menu_item">
                  <div className="l_c_menu_ico">
                    <div className="ico">
                      <div>feedback</div>
                    </div>
                  </div>
                  <div className="l_c_menu_label">
                    <div>Feedback</div>
                  </div>
                </div>
              </div>
              <div className="l_c_menu_li">
                <div className="l_c_menu_item">
                  <div className="l_c_menu_ico">
                    <div className="m_user_avatar" />
                  </div>
                  <div className="l_c_menu_label">
                    <div>mikoza@gmail.com</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </>}



    </>
  );
}




function MenuPlaylist({ id, uniq, title, emoji, icon, active, match }) {
  const context = useContext(Context);
  return (
    <>
      <Link to={`/${match.params['space']}/list/${uniq}`} className={`l_c_menu_item ${active ? 'active' : ''}`}>

        <div className="l_c_menu_ico">

          {Boolean(emoji) && <div className="m_ico m_ico_emojis">{emoji}</div>}
          {Boolean(icon) && <div className="m_ico">{icon}</div>}
          {!Boolean(emoji) && !Boolean(icon) && <div className="ico">list</div>}


        </div>
        <div className="l_c_menu_label">
          {title}
        </div>


      </Link>
    </>
  );
}


const MenuInner = withRouter(MenuInnerInner);